import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DAYS, MONTHS, nameMonth, YEARS } from '../../../utils/DateUtils';

const { id: module_id } = module;

const DueDate = ({ dueDate, setDueDate }) => (
  <article className="ot-appointment-due-date">
    <h2 className={'subheading-gray required'}>
      <FormattedMessage id={`${module_id}.select.dueDate`} />
    </h2>

    <form>
      <select
        name="day"
        role="listbox"
        className="ot-appointment-due-date-select"
        value={dueDate.date}
        onChange={(event) =>
          setDueDate({ ...dueDate, date: event.target.value })
        }
      >
        {DAYS(dueDate.month, dueDate.year).map((day, idx) => {
          return (
            <option key={day + idx} role="option" value={day}>
              {day}
            </option>
          );
        })}
      </select>
      <span> / </span>
      <select
        name="month"
        role="listbox"
        value={dueDate.month}
        className="ot-appointment-due-date-select"
        onChange={(event) =>
          setDueDate({ ...dueDate, month: event.target.value })
        }
      >
        {MONTHS().map((month, idx) => {
          return (
            <option key={month + idx} role="option" value={month}>
              {nameMonth(month)}
            </option>
          );
        })}
      </select>
      <span> / </span>
      <select
        name="year"
        role="listbox"
        value={dueDate.year}
        className="ot-appointment-due-date-select"
        onChange={(event) =>
          setDueDate({ ...dueDate, year: event.target.value })
        }
      >
        {YEARS().map((year, idx) => {
          return (
            <option key={year + idx} role="option" value={year}>
              {year}
            </option>
          );
        })}
      </select>
    </form>
  </article>
);

export default DueDate;
